<template>
    <div>
        <el-card class='card_warp'>
            <el-form label-width="200px" ref='form'
             class="form">
                <el-form-item label="关键词" class="is-required">
					<el-input
					class="form_item_width_m"
					placeholder="请输入内容"
					v-model="form.keyword"
					maxlength="999"></el-input>
					<!-- <span style="color: grey; font-size: 13px">字数限制20字内</span> -->
				</el-form-item>
                <el-form-item label="有效期" class="is-required">
                    <div>
                        <el-radio v-model="form.isPermanent" :label="false" v-removeAriaHidden>指定时间</el-radio>
                        <el-date-picker size='small'
                            v-if="!form.isPermanent"
                            v-model="timeRange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="daterange"
                            :default-time="['00:00:00', '23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="updateDom">
                        </el-date-picker>
                    </div>
                    <div>
                        <el-radio v-model="form.isPermanent" :label="true" v-removeAriaHidden>永久</el-radio>
                    </div>
                </el-form-item>
				<el-form-item label="推荐课程源" class="is-required">
                    <el-button type="primary" plain class="form_item_width_m"
                     @click="openSelectCourseOrgin">
                        <i class="iconfont icon-add"></i>
                        关联课程源
                    </el-button>
                    <div v-for="(child, num) in form.courseSourceRecommend" :key="num"
                        class="card">
                        <el-card class="courseItem">
                            <span>{{ child.recommendContent }}</span>
                        </el-card>
                        <div class="weight">
                            <span style="color: #f56c6c">* </span>
                            <span>权重</span>
                            <el-input-number
                            size="small"
                            class="inp"
                            placeholder="请输入"
                            :min="0"
                            @change="updateDom"
                            v-model.trim="child.ratio"
                            ></el-input-number>
                        </div>
                        <div class="remove">
                            <el-button type="danger" size="mini" @click="removeItem('courseSourceRecommend', num)">删除</el-button>
                        </div>
                    </div>

                    <div style="margin-top: 20px;">
                        <el-button type="warning" plain class="form_item_width_m"
                        @click="openAddLink">
                            <i class="iconfont icon-add"></i>
                            关联链接
                        </el-button>
                    </div>
                    <div v-for="(child, num) in form.linkRecommend" :key="child.icon"
                        class="card">
                        <el-card class="courseItem">
                            <span>{{ child.recommendContent }}</span>
                        </el-card>
                        <div class="weight">
                            <span style="color: #f56c6c">* </span>
                            <span>权重</span>
                            <el-input-number
                            size="small"
                            class="inp"
                            placeholder="请输入"
                            :min="0"
                            @change="updateDom"
                            v-model.trim="child.ratio"
                            ></el-input-number>
                        </div>
                        <div class="remove">
                            <el-button type="danger" size="mini" @click="removeItem('linkRecommend', num)">删除</el-button>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item style='marginTop:40px;'>
                    <el-button type="warning" @click="closePage()">取 消</el-button>
                    <el-button type="primary" :loading="apiLock" @click="submit()">保 存</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!--选择课程源组件-->
        <select-course ref="selectCourseOrgin" :userType="2" @select-submit="choiceCourseCallback"> </select-course>
        <!-- 新增链接 -->
        <el-dialog center
	      title="新增链接"
	      :visible.sync="dialog.show"
	      width="650px"
          class='dialog'
          :close-on-click-modal="false">
	    	<template>
                <el-form label-width="100px">
                    <el-form-item label="链接标题" class="is-required">
                        <el-input v-model.trim="dialog.data.recommendContent" maxlength="9999">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="图标" class="is-required">
                        <el-upload
                        class="avatar-uploader"
                        :action="commonUrl.uploadImg"
                        :headers="commonUrl.headers"
                        :data="mediaObj"
                        :multiple="false"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="uploadSuccess">
                            <div v-if="dialog.data.recommendIcon" class="avatar">
                                <img :src="commonUrl.imgPrefix + dialog.data.recommendIcon" />
                                <i class="el-icon-edit avatar_edit"></i>
                            </div>
                            <i v-else class="iconfont icon-picture-add"></i>
                        </el-upload>
                        <span style="color: grey; font-size: 13px">尺寸建议：1:1，尺寸200*200</span>
                    </el-form-item>
                    <el-form-item label="链接地址" class="is-required">
                        <el-input v-model.trim="dialog.data.recommendUrl">
                        </el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="warning" @click="dialog.show = false">取 消</el-button>
                    <el-button type="primary" @click="addLink">添 加</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>
<script scoped>
import commonApi from '@/api/common'
import requestApi from '@/api/operateManage/AIManage'
import selectCourse from '@/components/selectSource/selectCourseOrgin'
export default {
    name: 'courseSourcePage',
    components: {
        selectCourse
    },
    props: {
        PAGEKEY: {
            type: String,
            default: () => ''
        },
        PAGEBACK: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            commonUrl: commonApi.commonUrl,
            id: '',
            pageType: '',
            apiLock: false,
            form: {
                keyword: '',
                isPermanent: false,
                courseSourceRecommend: [],
                linkRecommend: [],
            },
            timeRange: [],
            courseIds: [],
            mediaObj: {
                mediaJson: JSON.stringify({
                    type: 0
                })
            },
            dialog: {
                show: false,
                data: {
                    recommendContent: '',
                    recommendIcon: '',
                    recommendUrl: '',
                    ratio: 0
                }
            }
        }
    },
    
    activated() {
        if (this.$route.params.id === this.sourceId && this.$route.params.type === this.pageType) {
            return
        }
        // 设置课程源信息
        this.id = this.$route.params.id
        this.pageType = this.$route.params.type
        if (this.id) {
            this.getDetail(this.id)
        }
    },

    methods: {
        //打开选择课程源
        openSelectCourseOrgin() {
            this.$refs.selectCourseOrgin.getData()
            this.$refs.selectCourseOrgin.open('选择课程源')
        },
        getDetail(id) {
            requestApi.detailKey({ id: id }).then((res) => {
                if (res.Success) {
                    res.Data.courseSourceRecommend = res.Data.courseSourceRecommend || []
                    res.Data.linkRecommend = res.Data.linkRecommend || []
                    this.form = res.Data
                    if(this.form.effectiveStartTime) {
                        this.timeRange = [this.form.effectiveStartTime, this.form.effectiveEndTime]
                    }
                } else {
                    this.$message.error(res.Msg)
                }
            })
        },
        choiceCourseCallback(course) {
            let courses = []
            let courseIds = []
            let courseListCurrent = this.form.courseSourceRecommend || []
            let courseIdsCurrent = courseListCurrent.map(item => item.courseSourceId)
            let index = 0
            for (let i = 0; i < course.length; i++) {
                if (courseIdsCurrent.includes(course[i].id)) {
                    continue
                }
                courses[index] = {
                    recommendContent: course[i].title,
                    courseSourceId: course[i].id,
                    ratio: 0
                }
                courseIds[index] = course[i].id
                index ++
            }
            this.courseIds = courseIdsCurrent.concat(courseIds)
            this.form.courseSourceRecommend = courseListCurrent.concat(courses)
        },
        openAddLink() {
            this.dialog.show = true
        },
        uploadSuccess(res) {
            res = this.$apiOldResDeal(res)
            if (!res.Success) {
                this.$message.error(res.Msg)
            } else {
                this.dialog.data.recommendIcon = res.Data.url;
                this.$forceUpdate()
                this.$message.success('上传成功')
            }
        },
        // 添加链接
        addLink() {
            if(!this.dialog.data.recommendContent || !this.dialog.data.recommendUrl
                || !this.dialog.data.recommendIcon
            ) {
                this.$message.error('请输入完整信息')
                return
            }
            this.form.linkRecommend.push(this.dialog.data)
            this.dialog.show = false
            this.dialog.data = {
                recommendContent: '',
                recommendIcon: '',
                recommendUrl: '',
                ratio: 0
            }
        },
        removeItem(type, index) {
            this.form[type].splice(index, 1)
        },
        submit() {
            let data = this.form
            if(!data.isPermanent) {
                data.effectiveStartTime = this.timeRange && this.timeRange[0] || ''
                data.effectiveEndTime = this.timeRange && this.timeRange[1] || ''
            } else {
                delete data.effectiveStartTime
                delete data.effectiveEndTime
            }
            if (!data.keyword || 
            !data.isPermanent && !data.effectiveStartTime || 
            data.courseSourceRecommend.length === 0 && data.linkRecommend.length === 0) {
                this.$message.error('请输入完整信息')
                return
            }
            for(let i in data.courseSourceRecommend) {
                if (data.courseSourceRecommend[i].ratio === undefined) {
                    this.$message.error('请填写权重')
                    return
                }
            }
            for(let i in data.linkRecommend) {
                if (data.linkRecommend[i].ratio === undefined) {
                    this.$message.error('请填写权重')
                    return
                }
            }
            if(this.id) {
                data.id = this.id
            }
            requestApi.addKey(data).then(res => {
                if(res.Success) {
                    this.$message.success('操作成功')
                    this.closePage()
                } else {
                    this.$message.error(res.Msg)
                }
            })
        },
        //取消钩子
        closePage() {
            this.$store.dispatch('tabs/removeSpecifiedTab', this.PAGEKEY)
            this.$store.dispatch('tabs/toTargetTab', this.PAGEBACK)
        },
        updateDom() {
            this.$forceUpdate()
        }
    }
}
</script>

<style lang="less" scoped>
    .form_item_width_m {
        width: 400px;
    }
    .card{
        display: flex;
        align-items: center;
        margin-top: 20px;
        .courseItem{
            flex: none;
            width: 400px;
        }
        .weight{
            flex: none;
            margin-left: 10px;
        }
        .remove{
            flex: none;
            margin-left: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/operateManage/AIAnswerKey/components/page.vue